"use client"
import React, { useEffect, useState } from 'react'
import EventSlider from './EventSlider';
import { EventBannerResponse, PromotionBannerResponse, SubPromotionBanner } from '@/services/dataTypes';
import '@/components/shared/CompanyMainBanner/companybanner.css';

interface Props {
    domain: string;
    banners: EventBannerResponse[] | PromotionBannerResponse[] | SubPromotionBanner[];
    eventName: string;
}

const EventBanner = ({ domain, banners, eventName }: Props) => {
    const [hydrated, setHydrated] = useState(false)
    useEffect(() => setHydrated(true), [])

    if (!banners || banners.length === 0) return null

    return (
        <div className="banner-sections index-one overflow-hidden position-relative mx-2 mx-md-4 mx-xl-6 my-2 my-md-4 my-xl-6">
            <div
                className="slider-container-wrapper"
                style={{
                    width: '100%',
                    height: '100%',
                    margin: '0 auto',
                    position: 'relative',
                    overflow: 'hidden',
                    borderRadius: '12px',
                }}
            >
                <div className="slider-hydration-wrapper" style={{ position: 'relative', maxWidth: "100%" }}>
                    <div
                        className="hydrated-slider"
                        style={{ opacity: hydrated ? 1 : 0, transition: 'opacity 0.3s ease' }}
                    >
                        <EventSlider sliders={banners} domain={domain} eventName={eventName} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EventBanner